var $8b5d459f86e9b23c$exports = {};
$8b5d459f86e9b23c$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " \u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002");
  },
  "longPressToSelect": "\u9577\u62BC\u3057\u3057\u3066\u9078\u629E\u30E2\u30FC\u30C9\u3092\u958B\u304D\u307E\u3059\u3002",
  "select": "\u9078\u629E",
  "selectedAll": "\u3059\u3079\u3066\u306E\u9805\u76EE\u3092\u9078\u629E\u3057\u307E\u3057\u305F\u3002",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "\u9805\u76EE\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
      one: function one() {
        return "".concat(formatter.number(args.count), " \u9805\u76EE\u3092\u9078\u629E\u3057\u307E\u3057\u305F");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u9805\u76EE\u3092\u9078\u629E\u3057\u307E\u3057\u305F");
      }
    }), "\u3002");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " \u3092\u9078\u629E\u3057\u307E\u3057\u305F\u3002");
  }
};
export { $8b5d459f86e9b23c$exports as default };